import React from 'react';

import Box from '@mui/material/Box';
import ScrollProvider from './scroll-context';

const AppContainer = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        '@media screen': { backgroundColor: 'appBackground.main' },
        width: '100%',
        height: '100%'
      }}
    >
      <ScrollProvider>{children}</ScrollProvider>
    </Box>
  );
};

export default AppContainer;
